import clsx from 'clsx';
import { Link } from 'react-router-dom';

type IButtonProps = {
  path: string;
  to: string;
  label: string;
};

const SubNavMenuButton = ({ path, to, label }: IButtonProps) => {
  return (
    <Link
      to={to}
      className={clsx(
        'px-3 py-2 rounded-md text-xs font-medium',
        path.startsWith(to) && 'text-white bg-gray-900',
        path.startsWith(to) && 'focus:outline-none focus:text-white focus:bg-gray-700',
        !path.startsWith(to) && 'text-gray-600 bg-white',
        !path.startsWith(to) && 'hover:text-white hover:bg-gray-700',
        !path.startsWith(to) && 'focus:outline-none focus:text-white focus:bg-gray-700',
      )}
    >
      {label}
    </Link>
  );
};

export default SubNavMenuButton;
